import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { columns } from "../../utils/columns";
import { FileStorage } from "src/api/types";
import { useSearchParams } from "react-router-dom";
import { LIMIT, PAGE } from "src/constants/searchParams";
import { ROWS_PER_PAGE } from "src/constants/rowPerPage";
import { ChangeEvent } from "react";
import PlansTableRow from "./components/PlansTableRow";
import TableHeaderCell from "src/shared/TableHeaderCell";

interface TableProps {
  plans: FileStorage[];
  total: number;
}

const PlansTable = ({ plans, total }: TableProps) => {
  const [params, setParams] = useSearchParams();
  const rawPage = params.get(PAGE);
  const rawLimit = params.get(LIMIT);

  const page = rawPage ? parseInt(rawPage, 10) : 0;
  const limit = rawLimit ? parseInt(rawLimit, 10) : ROWS_PER_PAGE[0];

  const handleChangePage = (_: unknown, newPage: number) => {
    params.set(PAGE, newPage.toString());
    setParams(params);
  };

  const handleChangeRowsPerPage = (e: ChangeEvent<HTMLInputElement>) => {
    params.set(LIMIT, e.target.value);
    params.set(PAGE, "0");
    setParams(params);
  };

  return (
    <Stack role="table">
      <TableContainer
        component={Paper}
        sx={{
          p: 0,
          boxShadow: "none",
          backgroundColor: "transparent",
        }}
      >
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{ borderCollapse: "separate", borderSpacing: "0 12px" }}
        >
          <TableHead
            sx={{
              borderRadius: "8px",
              border: "1px solid var(--teal, #569099)",
            }}
          >
            <TableRow>
              {columns.map((column) => (
                <TableHeaderCell column={column} key={column.id} />
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {plans.map((row) => (
              <PlansTableRow row={row} key={row.id} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ mr: 10 }}
        component="div"
        count={total}
        page={page}
        rowsPerPage={limit}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={ROWS_PER_PAGE}
      />
    </Stack>
  );
};

export default PlansTable;
